import React from "react";
import '../prepLaunchPod.css';

function BotGuruQueuePage({ error = false, onBack }) {
    return (
        <div className="botguru-queue-container">
            <div className="botguru-card">
                {error ? (
                    <>
                        <h1>⚠️ Request Denied</h1>
                        <p>
                            Due to heavy request load, we cannot complete your request right
                            now. Please try again later.
                        </p>
                        <button onClick={onBack} className="botguru-back-btn">
                            ← Go Back
                        </button>
                    </>
                ) : (
                    <>
                        <h1>🔄 Please Wait…</h1>
                        <p>
                            Your interview session with <strong>BotGuru</strong> has been
                            queued.
                        </p>
                        <div className="botguru-spinner" />
                    </>
                )}
            </div>
        </div>
    );
}

export default BotGuruQueuePage;
